<template>
    <div class="components-scrollExpert" >
        <div id="cont" class="cont" style="width:800px;">
            <div class="pr wh100 flex center cmm fs15">
					<div class="w100 pdlr20 pr" style="top: 30px;">
						<div class="w100 h300 br10 bd1d ofh">
							<div class="wh100 pr flex center" >
								<div class="w100 h100 bbx pd05 pr" style="top: 100px;">
		        					<div class="pr w100 bgf1 mart20 flex center" style="perspective:200;" >
		        						<div v-for="(v,k) in list_data" :key="k"  class="pa w100 h50 felx center cp sen hovbgb2 bbx t10 trs3" 
		        						:style="{'transform': 'rotateX(' +(deg*k + x1) +'deg) rotateY(0deg) translateZ(240px)','z-index': v.v,'opacity':v.v*0.006, }">
		        							<div class="wh100 flex center bgf">
		        								<div class="c111 flex fs13 fsw trs3" :style="{'transform': 'scale(' + v.s + ')'}">
		        									<div class="wh40 br50 bgb1 marr10" :style="{
                                                        'background-image'  : `url('${v.img_avatar_full}')`,
                                                        'background-size'   : '100% 100%'
                                                    }">
                                                        <!-- <img :src="v.img_avatar_full" style="width:40px;height:40px;border-radius:40px;"></div> -->
                                                    </div>
		        									<div class="h40" >
		        										<div class="h20 flex left">
		        											<div class="w80"><span>姓名</span></div>
		        											<div class="w110"><span>联系方式</span></div>
		        										</div>
		        										<div class="h20 flex left">
		        											<div class="w80" style="font-size:12px;color:#6b6b6b;">
                                                                <span v-if="false">{{ (v.art_category_name||[]).join(",") }}</span>
                                                                <span v-else v-html="v.name"></span>
                                                            </div>
		        											<div class="w110 cb" style="color:#6d3232"><span >{{ v.mobile }}</span></div>
		        										</div>
		        									</div>
		        								</div>
		        							</div>
		        						</div>
		        					</div>
		        				</div>
							</div>
						</div>
					</div>
				</div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        dataList:{
            type : Array,
            default:function(){
                return [];
            }
        }
    },
    data(){
        return {
            "list_data" : [
            ],
            "animate"   : false,
            
            "config"    : {
                "base_scroll":5,

                "scroll":0,
                
            },
            "timer":null,
            deg: 12,
            x1:0,
        }
    },
    created(){
        this.list_data = this.fillArray((this.dataList || []).slice(0));
        this.setYck();
    },
    watch(){
        dataList:(val)=>{
            this.list_data = this.fillArray((val || []).slice(0));
            // this.setYck();
        }
    },
    mounted(){
        this.$nextTick(function(){
            this.timer = setInterval(()=>{
                this.loopPlay();
                // this.handelScroll();
            },300);
        });
    },
    destroyed(){
        clearInterval(this.timer);
    },
    methods: {
        fillArray(arr){
            var doFill = (a)=>{
                if(a.length==0){
                    return a;
                }
                if( a.length < 20 ){
                    var r = a.slice(0);
                    a.forEach(item => {
                        r.push(item);
                    });
                    return doFill(r);
                }else{
                    return a;
                }
            }
            
            var list = doFill(arr).map(item=>{
                item.s = 1;
                item.ht = '';
                item.v = 1;
                return item;
            });
            return list;
        },
        handelScroll(){
            var config = this.config;
            var dom  = document.querySelector(".cont")
            var first = dom.children[0];
            // console.log(first.offsetHeight , config.scroll );
            if( first.offsetHeight <= config.scroll  ){
                first = dom.children[0].cloneNode(true);
                var h = first.offsetHeight;
                dom.children[0].remove();
                this.config.scroll = 0;
                // first.style.marginTop = `-0px`;
                document.querySelector(".cont").appendChild(first);
                document.querySelector(".cont").lastChild.style.marginTop = `-0px`;
                
                this.config.scroll = this.config.scroll - h;
            }else{
                this.config.scroll += config.base_scroll;
                first.style.marginTop = `-${this.config.scroll}px`;
            }
            // setTimeout(()=>{
            //     this.handelScroll();
            // },10);
        },
        loopPlay: function () {
            this.onwheell({deltaY: 1});
        },
        onwheell: function (e) {
            var _this = this;
            var deg = _this.deg
            var y = e.deltaY > 0 ? deg : e.deltaY < 0 ? -deg : 0;
            _this.x1 += y;
            _this.setYck()
        },
        setYck: function () {
            var _this = this;
            var list_data = _this.list_data.slice(0);
            console.log(list_data);
            
            for (let i = 0; i < _this.list_data.length; i++) {
                
                var d = (_this.deg*i + _this.x1)%360 ;
                if (d < 0) d = -d;
                d = (180 - d);
                if (d < 0) d = -d;
                d = (d - 120) / 60 *180;
                var item = {...list_data[i]};
                item['v'] = d;
                this.list_data[i] = item;
                var x = d / 360;
                if (x < 0) x = -x;
                x = 1-x;
                if (x < 0.5) x = 0.5;
                x = 1 - x + 0.5;
                _this.list_data[i].s = x
            }
        },
    }
}
</script>

<style lang="less" scoped>
.components-scrollExpert{
    width:100%;height:300px;overflow: hidden;
    .cont{
        height: 280px;overflow: hidden;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;

        // .item{
        //     transition: all 0.3s;
        //     justify-content: center;
        //     text-align: center;

        //     .info{
        //         display: inline-block;
        //         width: 100%;
        //         padding:10px 0px;
        //         .avatar,.data{
        //             display: inline-block;
        //             vertical-align: middle;
        //         }
        //         .avatar{
        //             width:40px;height:40px;border-radius: 40px;overflow: hidden;
        //             box-shadow: 1px 1px 10px rgba(0,0,0,0.5);
        //             img{
        //                 width:100%;
        //                 height: 100%;
        //             }
        //         }
        //         .data{
        //             margin-left: 20px;
        //             // max-width: calc(100% - 40px - 20px);
        //             width: 150px;
        //             text-align: left;
        //             .top{
        //                 font-weight: bold;
        //                 font-size: 16px;
                        
        //             }
        //             .bottom{
        //                 font-size: 16px;
        //                 color:#a2a2a2;
        //             }
        //         }
        //     }
        // }
    }
}
</style>

<style type="text/css">
			.pa{position: absolute;}
			.pr{position: relative;}
			.pf{position: fixed;}
			.disi{display: inline-block;}
			.disn{display: none;}
			.flex{display: flex;align-items: center;}
			.flw{flex-wrap:wrap;}
			.fla{align-items: flex-start!important;}
			.flc{flex-direction: column;}
			.flex1{flex:1;}
			.flex2{flex:2;}
			.flex3{flex:3;}
			.flex4{flex:4;}
			.flex5{flex:5;}
			.flex7{flex:7;}
			.t0{top: 0px}
			.t1{top: 1px;}
			.t2{top: 2px;}
			.t5{top: 5px;}
			.t6{top: 6px;}
			.t8{top: 8px;}
			.t10{top: 10px}
			.t15{top: 15px}
			.t20{top: 20px}
			.t40{top: 40px}
			.t60{top: 60px}
			.t80{top: 80px}
			.t85{top: 85px}
			.t90{top: 90px}
			.t100{top: 100px}
			.t105{top: 105px}
			.r0{right: 0px;}
			.r5{right: 5px;}
			.r01{right: -1px;left: -1px;}
			.r05{right: -5px;}
			
			.r010{right: -10px;}
			.r050{right: -50px;}
			.r1{right: 1px;}
			.r10{right: 10px;}
			.r15{right: 15px;}
			.r20{right: 20px;}
			.r50{right: 50px;}
			.r80{right: 80px;}
			.b0{bottom: 0px;}
			.b2{bottom: 2px;}
			.b4{bottom: 4px;}
			.b5{bottom: 5px;}
			.b10{bottom: 10px;}
			.b15{bottom: 15px}
			.b20{bottom: 20px}
			.b45{bottom: 45px}
			.b50{bottom: 50px}
			.b100{bottom: 100px;}
			.l0{left: 0px;}
			.l1{left: 1px;}
			.l5{left: 5px;}
			.l10{left: 10px}
			.l20{left: 20px}
			.l50{left: 50px}
			.l200{left: 200px}
			.w0{width: 0px;}
.w1{width: 1px;}
.w4{width: 4px;}
.w5{width: 5px;}
.w10{width: 10px;min-width: 10px;}
.w12{width: 12px;min-width: 10px;}
.w15{width: 15px;min-width: 15px;}
.w18{width: 18px;min-width: 18px;}
.w20{width: 20px;min-width: 10px;}
.w25{width: 25px;}
.w30{width: 30px;}
.w35{width: 35px;}
.w40{width: 40px;}
.w45{width: 45px;}
.w50{width: 50px;}
.w55{width: 55px;}
.w60{width: 60px;}
.w65{width: 65px;}
.w70{width: 70px;}
.w75{width: 75px;}
.w80{width: 80px;}
.w85{width: 85px;}
.w90{width: 90px;}
.w95{width: 95px;}
.w101{width: 100px;}
.w110{width: 110px;}
.w120{width: 120px;}
.w125{width: 125px;}
.w130{width: 130px;}
.w135{width: 135px;}
.w140{width: 140px;}
.w150{width: 150px;}
.w160{width: 160px;}
.w170{width: 170px;}
.w180{width: 180px;}
.w190{width: 190px;}
.w200{width: 200px;}
.w220{width: 220px;}
.w240{width: 240px;}
.w250{width: 250px;}
.w256{width: 256px;}
.w260{width: 260px;}
.w270{width: 270px;}
.w280{width: 280px;}
.w300{width: 300px;}
.w320{width: 320px;}
.w330{width: 330px;}
.w340{width: 340px;}
.w350{width: 350px;}
.w380{width: 380px;}
.w400{width: 400px;}
.w420{width: 420px;}
.w450{width: 450px;}
.w480{width: 480px;}
.w500{width: 500px;}
.w510{width: 510px;}
.w530{width: 530px;}
.w550{width: 550px;}
.w580{width: 580px;}
.w600{width: 600px;}
.w650{width: 650px;}
.w680{width: 680px;}
.w700{width: 700px;}
.w750{width: 750px;}
.w800{width: 800px;}
.w850{width: 850px;}
.w900{width: 900px;}
.w950{width: 950px;}
.w1000{width: 1000px;}
.w1180{width: 1180px;}
.w1200{width: 1200px;}

.w10p{width: 10%;}
.w15p{width: 15%;}
.w20p{width: 20%;}
.w25p{width: 25%;}
.w30p{width: 30%;}
.w33p{width: 33.33%;}
.w40p{width: 40%;}
.w50p{width: 50%;}
.w60p{width: 60%;}
.w70p{width: 70%;}
.w80p{width: 80%;}
.w90p{width: 90%;}
.w100{width: 100%;}

.ha{height: auto;}
.h0{height: 0px;}
.h00{height: 0%;}
.h1{height: 1px;}
.h2{height: 2px;}
.h3{height: 3px;}
.h4{height: 4px;}
.h5{height: 5px;}
.h8{height: 8px;}
.h10{height: 10px;min-height: 10px;}
.h12{height: 12px;min-height: 10px;}
.h13{height: 13px;min-height: 10px;}
.h15{height: 15px;}
.h18{height: 18px;}
.h20{height: 20px;}
.h22{height: 22px;}
.h25{height: 25px;}
.ch25h30 .h25{height: 30px;}
.h30{height: 30px;}
.h35{height: 35px;}
.h38{height: 38px;}
.h40{height: 40px;}
.h42{height: 42px;}
.h45{height: 45px;}
.h50{height: 50px}
.h55{height: 55px}
.h60{height: 60px}
.h65{height: 65px}
.h70{height: 70px;}
.h75{height: 75px;}
.h80{height: 80px;}
.h85{height: 85px;}
.h90{height: 90px;}
.h95{height: 95px;}
.h99{height: 99px;}
.h101{height: 100px;}
.h110{height: 110px;}
.h120{height: 120px}
.h125{height: 125px;}
.h130{height: 130px;}
.h135{height: 135px;}
.h140{height: 140px;}
.h150{height: 150px;}
.h160{height: 160px;}
.h170{height: 170px;}
.h180{height: 180px;}
.h190{height: 190px;}
.h200{height: 200px;}
.h220{height: 220px;}
.h240{height: 240px;}
.h250{height: 250px;}
.h260{height: 260px;}
.h270{height: 270px;}
.h280{height: 280px;}
.h300{height: 300px;}
.h320{height: 320px;}
.h350{height: 350px;}
.h340{height: 340px;}
.h400{height: 400px;}
.h450{height: 450px;}
.h500{height: 500px;}
.h550{height: 550px;}
.h600{height: 600px;}
.h800{height: 800px;}
.h9000{height: 9000px;}
.h0p{height: 0%;}
.h5p{height: 5%;}
.h10p{height: 10%;}
.h20p{height: 20%;}
.h25p{height: 25%;}
.h30p{height: 30%;}
.h50p{height: 50%;}
.h100{height: 100%;}
.hovh200:hover {height: 200px;}
.hovh300:hover {height: 300px;}
.hovh400:hover {height: 400px;}

.wh100{width: 100%;height: 100%;}
.wh200{width: 200px;height: 200px;}
.wh180{width: 180px;height: 180px;}
.wh150{width: 150px;height: 150px;}
.wh120{width: 120px;height: 120px;}
.wh101{width: 100px;height: 100px;}
.wh90{width: 90px;height: 90px;}
.wh80{width: 80px;height: 80px;}
.wh70{width: 70px;height: 70px;}
.wh60{width: 60px;height: 60px;}
.wh50{width: 50px;height: 50px;}
.wh45{width: 45px;height: 45px;}
.wh40{width: 40px;height: 40px;}
.wh35{width: 35px;height: 35px;}
.wh30{width: 30px;height: 30px;}
.wh25{width: 25px;height: 25px;}
.wh20{width: 20px;height: 20px;}
.wh18{width: 18px;height: 18px;}
.wh15{width: 15px;height: 15px;}
.wh12{width: 12px;height: 12px;}
.wh10{width: 10px;height: 10px;}
.wh5{width: 5px;height: 5px;}

.cfff{color: #FFFFFF;}
.ceee{color: #EEEEEE;}
.cddd{color: #DDDDDD;}
.cccc{color: #CCCCCC;}
.cbbb{color: #BBBBBB;}
.caaa{color: #AAAAAA;}
.c999{color: #999999;}
.c666{color: #666666;}
.c333{color: #333333;}
.c111{color: #111111;}
.c000{color: #000000;}
.cf00{color: #ff0000;}
.c0f0{color: #00ff00;}
.c00f{color: #0000ff;}
.cff0{color: #ffff00;}
.c0ff{color: #00ffff;}
.cf0f{color: #ff00ff;}
.c212{color: #212121;}
.cr{color: red;}
.cb{color: blue;}
.cg{color: green;}
.cy{color: yellow;}
.co{color: orange;}
.cpri{color: #2d8cf0;}
.hovcpri:hover{color: #2d8cf0;}
.c383{color: #383838;}
.cpri{color: #2d8cf0;}
.cp{cursor: pointer;}
.cm{cursor: context-menu;}
.cmo{cursor: move;}
.ce{cursor: e-resize;}

.bg00{background-color: rgba(0,0,0,0);}
.bg001{background-color: #000c17;}
.bg0{background-color: #000000;}
.bgf{background-color: #FFFFFF;}
.bge{background-color: #EEEEEE;}
.bge5{background-color: #e5e5e5;}
.bgd{background-color: #DDDDDD;}
.bgc{background-color: #CCCCCC;}
.bgc3{background-color: #333333;}
.bgb{background-color: #BBBBBB;}
.bgpri{background-color: #2d8cf0;}
.hovbgp:hover{background-color: #57a3f3;}
.bga{background-color: #AAAAAA;}
.bgf1{background-color: #f1f1f1;}
.bgf5{background-color: #f5f5f5;}
.bgf0{background-color: #f0f0f0;}
.bgf7{background-color: #f7f7f7;}
.bgfa{background-color: #fafafa;}
.bgfc{background-color: #fcfcfc;}
.bg38{background-color: #383838;}
.bgo{background-color: orange;}
.bgr{background-color: red;}
.bgy{background-color: yellow;}
.bgg{background-color: green;}
.bgb1{background-color: #c6ecfd;}
.bgb2{background-color: #1890ff;}
.bgb3{background-color: #428bca;}
.bgb4{background-color: #0d4d84;}
.bgr1{background-color: #f9b8b8;}
.bgr2{background-color: #f16666;}
.bgr3{background-color: #f90c0c;}
.bgr4{background-color: #c30202;}
.bgg1{background-color: #aafbdf;}
.bgg2{background-color: #3ef7bf;}
.bgg3{background-color: #00b981;}
.bgg4{background-color: #04865f;}
.bgo1{background-color: #f7c4b4;}
.bgo2{background-color: #fb8864;}
.bgo3{background-color: #ff5722;}
.bgo4{background-color: #dc3500;}

.bg01{background: rgba(0,0,0,0.1);}
.bg02{background: rgba(0,0,0,0.2);}
.bg03{background: rgba(0,0,0,0.3);}
.bg04{background: rgba(0,0,0,0.4);}
.bg05{background: rgba(0,0,0,0.5);}
.bg06{background: rgba(0,0,0,0.6);}
.bg07{background: rgba(0,0,0,0.7);}
.bg08{background: rgba(0,0,0,0.8);}
.bg09{background: rgba(0,0,0,0.9);}
.bgaf1{background: rgba(255, 255, 255, 0.1);}
.bgaf3{background: rgba(255, 255, 255, 0.3);}
.bgaf5{background: rgba(255, 255, 255, 0.5);}
.bgaf7{background: rgba(255, 255, 255, 0.7);}
.bgaf8{background: rgba(255, 255, 255, 0.8);}
.bgaf9{background: rgba(255, 255, 255, 0.9);}

.bbx{box-sizing: border-box;}
.bd10{border: 1px solid rgba(0,0,0,0);}
.bdlr1e{border-left: 1px solid #eeeeee;border-right: 1px solid #eeeeee;}
.bdlr1c{border-left: 1px solid #CCCCCC;border-right: 1px solid #CCCCCC;}
.bd1e{border: 1px solid #eee;}
.bdr1e{border-right: 1px solid #EEEEEE;}
.bdl1e{border-left: 1px solid #EEEEEE;}
.hh{height: 60px;}
.lw{width: 200px;}

.bdbrr{border-right: 1px solid red;border-bottom: 1px solid red;}
.bd1r{border: 1px solid red;}
.bd1b{border: 1px solid #bbbbbb}
.bd1c{border: 1px solid #ccc;}
.bd1d{border: 1px solid #ddd;}
.bd1a{border: 1px solid #AAAAAA;}
.bd19{border: 1px solid #999999;}
.bd16{border: 1px solid #666666;}
.bd13{border: 1px solid #333333;}
.bdf0{border: 1px solid #f0f0f0;}
.bdf5{border: 1px solid #f5f5f5}
.bdf7{border: 1px solid #f7f7f7;}
.bd1f{border: 1px solid #fff;}
.bd1x{border: 1px dashed #333333;}
.bdf2{border: 1px solid #f2f2f2;}
.bdblue{border: 1px solid #57A3F3;}
.bd01{border: 1px solid rgba(0,0,0,0.1);}
.bd02{border: 1px solid rgba(0,0,0,0.2);}
.bd03{border: 1px solid rgba(0,0,0,0.3);}
.bd2f{border: 2px solid #fff;}
.bd2e{border: 2px solid #eee;}
.bd2r{border: 2px solid #ff0000;}
.bd2a{border: 2px solid #aaa;}
.bd2b{border: 2px solid #71c7ff;}
.bd26{border: 2px solid #666666;}
.bd2d{border: 2px solid #ddd;}
.bd1n {border-width: 1px;border-style: solid;border-color: rgba(0,0,0,0);}
.bd2n {border-width: 2px;border-style: solid;border-color: rgba(0,0,0,0);}
.bd1p {border-width: 1px;border-style: solid;border-color: rgba(0,0,0,0);}
.bd2p {border-width: 2px;border-style: solid;border-color: rgba(0,0,0,0);}
.bdco {border-color: orange;}
.bd2co {border: 2px solid orange;}
.bd1co {border: 1px solid orange;}
.bdcb {border-color: #2db7f5;}
.bdce {border-color: #eeeeee;}
.bdca {border-color: #aaaaaa;}
.bdcf {border-color: #ffffff;}
.bdcc {border-color: #cccccc;}
.bdcc .bd1n {border-color: #cccccc;}
.bdca .bd1n {border-color: #aaaaaa;}
.bdcd .bd1n {border-color: #dddddd;}
.cover {object-fit: cover; }
.around{justify-content: space-around;}
.between{justify-content: space-between;}
.center{text-align: center;justify-content: center;}

.left{text-align: left;justify-content: flex-start;}
.right{text-align: right;justify-content: flex-end;}
.wrap{flex-wrap: wrap}
.jusity{word-break: break-all;text-align:justify; text-justify:inter-ideograph;text-overflow: ellipsis; text-align-last: justify;}
.jusityleft{word-break: break-all;text-align:justify; text-justify:inter-ideograph;text-overflow: ellipsis; text-align-last: left;}
.br2{border-radius:2px;}
.br3{border-radius:3px;}
.br4{border-radius:4px;}
.br5{border-radius:5px;}
.br7{border-radius:7px;}
.br8{border-radius:8px;}
.br10{border-radius:10px;}
.br12{border-radius:12px;}
.br14{border-radius:14px;}
.br15{border-radius:16px;}
.br16{border-radius:16px;}
.br20{border-radius:20px;}
.br30{border-radius:30px;}
.br49{border-radius:50px;}
.br50{border-radius:50%;}
.ifocus:focus {border-color: #57a3f3;box-shadow: 0 0 0 2px rgba(45,140,240,0.2);outline: 0}
.ihover:hover {border-color: #57a3f3;outline: 0}
.mar0{margin:0}
.mar5{margin:5px}
.mar01{margin-left: 1px;margin-right: 1px;}
.mar02{margin-left:2px;margin-right: 2px;}
.mar05{margin-left:5px;margin-right: 5px;}
.mar10{margin-left:10px;margin-right: 10px;}
.mar15{margin-left:15px;margin-right: 15px;}
.mar20{margin-left:20px;margin-right: 20px;}
.mar30{margin-left:30px;margin-right: 30px;}

.marl5{margin-left: 5px;}
.marl10{margin-left: 10px;}
.marl15{margin-left: 15px;}
.marl20{margin-left: 20px;}
.marl25{margin-left: 25px;}
.marl30{margin-left: 30px;}
.marl40{margin-left: 40px;}

.marr05{margin-right: -5px;}
.marr010{margin-right: -10px;}
.marr5{margin-right: 5px;}
.marr10{margin-right: 10px;}
.marr15{margin-right: 15px;}
.marr20{margin-right: 20px;}
.marr30{margin-right: 30px;}
.marr40{margin-right: 40px;}

.mart2{margin-top: 2px;}
.mart5{margin-top: 5px;}
.mart10{margin-top: 10px;}
.mart15{margin-top: 15px;}
.mart20{margin-top: 20px;}
.mart30{margin-top: 30px;}
.mart40{margin-top: 40px;}
.mart50{margin-top: 50px;}
.mart101{margin-top: 100px;}

.marb5 {margin-bottom: 5px;}
.marb10{margin-bottom: 10px;}
.marb20{margin-bottom: 20px;}
.marb30{margin-bottom: 30px;}

.martb5{margin-top: 5px;margin-bottom: 5px;}
.martb10{margin-top: 10px;margin-bottom: 10px;}
.martb20{margin-top: 20px;margin-bottom: 20px;}
.martb30{margin-top: 30px;margin-bottom: 30px;}

.pd0 {padding:0}
.pd1{padding: 1px;}
.pd5 {padding:5px;}
.pd10{padding:10px;}
.pd20{padding:20px;}
 
.pdl5{padding-left: 5px;}
.pdl10{padding-left: 10px;}
.pdl15{padding-left: 15px;}
.pdl18{padding-left: 18px;}
.pdl20{padding-left: 20px;}
.pdl25{padding-left: 25px;}
.pdl30{padding-left: 30px;}
.pdl40{padding-left: 40px;}

.pdr01{padding-right: -1px;padding-left: -1px;}
.pdr05{padding-right: -5px;}
.pdr010{padding-right: -10px;}
.pdr40{padding-right: 40px;}
.pdr25{padding-right: 25px;}
.pdr20{padding-right: 20px;}
.pdr18{padding-right: 18px;}
.pdr15{padding-right: 15px;}
.pdr10{padding-right: 10px;}
.pdr5{padding-right: 5px;}

.pdb5{padding-bottom: 5px}
.pdb10{padding-bottom: 10px}
.pdb15{padding-bottom: 15px}
.pdb20{padding-bottom: 20px}

.pdt5{padding-top: 5px;}
.pdt10{padding-top: 10px;}
.pdt15{padding-top: 15px;}
.pdt20{padding-top:20px;}
.pdt25{padding-top:25px;}
.pdt30{padding-top:30px;}
.pdt40{padding-top:40px;}
.pdt50{padding-top:50px;}
.pdt70{padding-top:70px;}
.pdt80{padding-top:80px;}
.pdt135{padding-top:135px;}

.pdtb0{padding-top: 0px;padding-bottom: 0px;}
.pdtb3{padding-top: 3px;padding-bottom: 3px;}
.pdtb4{padding-top: 4px;padding-bottom: 4px;}
.pdtb5{padding-top: 5px;padding-bottom: 5px;}
.pdtb6{padding-top: 6px;padding-bottom: 6px;}
.pdtb7{padding-top: 7px;padding-bottom: 7px;}
.pdtb10{padding-top: 10px;padding-bottom: 10px;}
.pdtb15{padding-top: 15px;padding-bottom: 15px;}
.pdtb20{padding-top: 20px;padding-bottom: 20px;}
.pdtb25{padding-top: 25px;padding-bottom: 25px;}
.pdtb30{padding-top: 30px;padding-bottom: 30px;}
.pdtb40{padding-top: 40px;padding-bottom: 40px;}
.pdtb45{padding-top: 45px;padding-bottom: 45px;}
.pdtb50{padding-top: 50px;padding-bottom: 50px;}
.pdb50{padding-bottom: 50px;}

.pd05{padding-left: 5px;padding-right: 5px;}
.pd010{padding-left: 10px;padding-right: 10px;}
.pd012{padding-left: 12px;padding-right: 12px;}
.pdlr10{padding-left: 10px;padding-right:10px;}
.pdlr12{padding-left: 12px;padding-right:12px;}
.pdlr15{padding-left: 15px;padding-right:15px;}
.pdlr18{padding-left: 18px;padding-right:18px;}
.pdlr20{padding-left: 20px;padding-right:20px;}
.pdlr25{padding-left: 25px;padding-right:25px;}
.pdlr30{padding-left: 30px;padding-right:30px;}
.pdlr50{padding-left: 50px;padding-right:50px;}

.lh14{line-height: 14px;}
.lh15{line-height: 15px;}
.lh16{line-height: 16px;}
.lh18{line-height: 18px;}
.lh20{line-height: 20px;}
.lh25{line-height: 25px;}
.lh30{line-height: 30px;}
.lh35{line-height: 35px;}
.lh40{line-height: 40px;}
.lh45{line-height: 45px;}
.lh50{line-height: 50px;}

.fsw{font-weight:bold;}
.fs8{font-size: 8px;}
.fs9{font-size: 9px;}
.fs10{font-size: 10px;}
.fs11{font-size: 11px;}
.fs12{font-size: 12px;}
.fs13{font-size: 13px;}
.fs14{font-size: 14px;}
.fs15{font-size: 15px;}
.fs16{font-size: 16px;}
.fs17{font-size: 17px;}
.fs18{font-size: 18px;}
.fs19{font-size: 19px;}
.fs20{font-size: 20px;}
.fs22{font-size: 22px;}
.fs24{font-size: 24px;}
.fs26{font-size: 26px;}
.fs28{font-size: 28px;}
.fs30{font-size: 30px;}
.fs32{font-size: 32px;}
.fs40{font-size: 40px;}
.fs50{font-size: 50px;}
.bl1f{border-left: 1px solid #ffffff;}
.bl1x{border-left: 1px dashed #333333;}
.br1f5{border-right: 1px solid #f5f5f5;}
.br105{border-right: 1px solid rgba(255, 255, 255, 0.5);}
.br100{border-right: 1px solid rgba(255, 255, 255, 0);}
.br1c{border-right: 1px solid #cccccc;}
.bb1x{border-bottom: 1px dashed #333333;}
.bb1f{border-bottom: 1px solid #fff;}
.bb1a{border-bottom: 1px solid #aaa;}
.bb1b{border-bottom: 1px solid #bbbbbb;}
.bb1c{border-bottom: 1px solid #cccccc;}
.bb1d{border-bottom: 1px solid #ddd;}
.bb1e5{border-bottom: 1px solid #e5e5e5;}
.bb1e{border-bottom: 1px solid #eee;}
.bt1f{border-top: 1px solid #fff;}
.bt1d{border-top: 1px solid #ddd;}
.bdn{border: none;outline: none;background: transparent;}
.bdn th,td{border-width: 0px;}
.oln{outline: none;}
.bdtb1e{border-top: 1px solid #EEEEEE;border-bottom: 1px solid #EEEEEE;}
.bdtb1c{border-top: 1px solid #CCCCCC;border-bottom: 1px solid #CCCCCC;}
.bdtb1d{border-top: 1px solid #DDDDDD;border-bottom: 1px solid #DDDDDD;}
.cmm{color: #927120}
.bgcrr{background-color: #b11212;}
.ofh{overflow: hidden;}
.ovy{overflow-y: auto;}
.ovx{overflow-x: auto;}
.oxh{overflow-x: hidden;}
.oyh{overflow-y: hidden;}
.r{border:1px solid red}
.g{border:1px solid green}
.b{border:1px solid blue}
.a{opacity: 0;}
.a1{opacity: 1;}
.mopa3{opacity: 0.3;}
.mopa5{opacity: 0.5;}
.mopa7{opacity: 0.7;}
.mopa8{opacity: 0.8;}
.z0{z-index: 0;}
.z1{z-index: 1;}
.z2{z-index: 2;}
.z3{z-index: 3;}
.z4{z-index: 4;}
.z5{z-index: 5;}
.z6{z-index: 6;}
.z7{z-index: 7;}
.z8{z-index: 8;}
.z9{z-index: 9;}
.z10{z-index: 10;}
.z11{z-index: 11;}
.trs8{transition: 0.8s;transition-timing-function: linear;}
.trs4{transition: 0.4s;transition-timing-function: linear;}
.trs3{transition: 0.3s;transition-timing-function: linear;}
.trs2{transition: 0.2s;transition-timing-function: linear;}
.trs1{transition: 0.1s;transition-timing-function: ease-out;;}
.trs05{transition: 0.05s;}
.cbl1{color: #11a6eb;}
.cb22{color: #2f57b3;}
.fbh {height: 40px;}
.navh {height: 50px;}
.sp1 {letter-spacing: 1px;}
.sp2 {letter-spacing: 2px;}

		</style>